<template>
  <section class="contact">
        <div class="contact-content">
            <h2>Contatos</h2>
            <div class="contact-content-item">
                <contact-info :is-dark="true" />
            </div>
            <div class="contact-content-item">
                <h4><img src="@/assets/img/svg/map_marker.svg">ENDEREÇOS</h4>
                <div class="contact-address" v-for="item in addresses" :key="item.title">
                    <h5>{{ item.title }}</h5>
                    <p>{{ item.text }}</p>
                </div>
            </div>
        </div>
  </section>
</template>

<script>

import ContactInfo from "@/components/ContactInfo";

export default {

    components: { ContactInfo },

    computed: {
        addresses() {
            return [
                {title: 'São Paulo', text: "Rua Boa Vista, 254, 12º andar, Cj. 1209\nCentro - CEP 01014-000 - São Paulo/SP"},
                {title: 'Brasília', text: "SAUS Quadra 5 Bloco K, SALA 903-904, Cj. 11\nAsa Sul - CEP 70070-050 - Brasília/DF"},
                {title: 'Ribeirão Preto', text: "Av. Presidente Vargas, 2121, Cj. 2302, Sala 09\nSanta Angela - CEP 14020-260 - Ribeirão Preto/SP"},
                {title: 'Osasco', text: "R. Presidente Castelo Branco, 45, Salas 709/710\nCentro - CEP 06013-070 - Osasco/SP"},
                {title: 'São Paulo - Funchal', text: "Rua Funchal, 418 – 35º andar\nVila Olímpia – CEP 04551-060 - São Paulo/SP"}
            ]
        }
    }

}
</script>

<style>

</style>
